import React from "react";

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Introduction</h2>
        <p className="mb-2">
          These Terms of Service govern your use of our service. By accessing or using our service, 
          you agree to be bound by these Terms. If you disagree with any part of the terms, you may not use our service.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Account Registration</h2>
        <p className="mb-2">
          To use certain features of the service, you may be required to register for an account. 
          You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
        </p>
        <p className="mb-2">
          You are responsible for safeguarding the password that you use to access the service and for any activities or actions under your password.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">User Content</h2>
        <p className="mb-2">
          Our service allows you to post, link, store, share and otherwise make available certain information, text, graphics, or other material. You are responsible for the content you post to the service.
        </p>
        <p className="mb-2">
          By posting content to the service, you grant us the right to use, modify, publicly perform, publicly display, reproduce, and distribute such content on and through the service.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Intellectual Property</h2>
        <p className="mb-2">
          The service and its original content, features, and functionality are and will remain the exclusive property of our company and its licensors.
        </p>
        <p className="mb-2">
          Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of our company.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Termination</h2>
        <p className="mb-2">
          We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
        </p>
        <p className="mb-2">
          Upon termination, your right to use the service will immediately cease. If you wish to terminate your account, you may simply discontinue using the service.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Limitation of Liability</h2>
        <p className="mb-2">
          In no event shall we be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Governing Law</h2>
        <p className="mb-2">
          These Terms shall be governed and construed in accordance with the laws, without regard to its conflict of law provisions.
        </p>
        <p className="mb-2">
          Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Changes to These Terms</h2>
        <p className="mb-2">
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice prior to any new terms taking effect.
        </p>
        <p className="mb-2">
          By continuing to access or use our service after those revisions become effective, you agree to be bound by the revised terms.
        </p>
      </section>
      
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
        <p className="mb-2">
          If you have any questions about these Terms, please contact us.
        </p>
      </section>
    </div>
  );
};

export default Terms; 